import type { Registry } from '../content/registry';
import type { Place } from '../content/types';

/**
 * Audit mode: `?showroom` lays every building (and vehicle) out on a paved grid far from
 * the origin so a human can walk/fly around them in the real 2.5D renderer.
 * Returns the place's origin so the player can be dropped there.
 */
export function addShowroom(reg: Registry, kind: 'building' | 'vehicle' | 'all' = 'all'): { x: number; y: number; w: number; h: number } {
  const X = 5000, Y = 5000, GAP = 4, ROW_W = 320;
  const buildings: Place['buildings'] = [];
  const spawns: Place['spawns'] = [];
  let cx = GAP, cy = GAP, rowH = 0;
  if (kind !== 'vehicle') {
    const defs = reg.all('building').sort((a, b) => a.footprint[0] * a.footprint[1] - b.footprint[0] * b.footprint[1] || a.id.localeCompare(b.id));
    for (const b of defs) {
      const [w, h] = b.footprint;
      if (cx + w + GAP > ROW_W) { cx = GAP; cy += rowH + GAP + 2; rowH = 0; }
      buildings.push({ id: b.id, x: cx, y: cy, rot: 0 });
      cx += w + GAP; rowH = Math.max(rowH, h);
    }
    cx = GAP; cy += rowH + GAP + 6; rowH = 0;
  }
  if (kind !== 'building') {
    for (const v of reg.all('vehicle').sort((a, b) => a.class.localeCompare(b.class) || a.id.localeCompare(b.id))) {
      const [w, l] = v.size;
      if (cx + w + GAP > ROW_W) { cx = GAP; cy += rowH + GAP; rowH = 0; }
      spawns.push({ vehicle: v.id, x: cx + w / 2, y: cy + l / 2, angle: 0 });
      cx += w + GAP; rowH = Math.max(rowH, l);
    }
    cy += rowH + GAP;
  }
  const place: Place = { id: 'showroom', name: 'Showroom', x: X, y: Y, w: ROW_W + GAP, h: cy + GAP, zone: 'downtown', terrain: 'pavement', roads: 'none', lots: 'none', buildings, spawns, tags: ['showroom'] };
  reg.add('place', 'runtime:showroom', place);
  return { x: X, y: Y, w: place.w, h: place.h };
}
